import { ClusterType, type ClusterWithCloudConnect } from "@doitintl/cmp-models";
import { Stack } from "@mui/material";
import uniqBy from "lodash/uniqBy";

import { isCloudConnectHealthy } from "../utils";
import ClusterConnectionIssueAlert from "./ClusterConnectionIssueAlert";

export interface ClusterConnectionIssue {
  cluster: ClusterWithCloudConnect;
}

type CloudConnectIssuesByClusterType = Partial<Record<ClusterType, ClusterConnectionIssue[]>>;

interface ClusterTableAlertsProps {
  clusters: ClusterWithCloudConnect[];
  loading?: boolean;
}

const ClusterTableAlerts = ({ clusters, loading }: ClusterTableAlertsProps) => {
  const clustersWithConnectionIssues = clusters.filter(
    (cluster) => cluster.type !== ClusterType.SELF_MANAGED && !isCloudConnectHealthy(cluster.cloudConnect)
  );

  // If we have multiple clusters with issues for the same cloud connect doc, we take only one
  const uniqueClustersByProjectId = uniqBy(clustersWithConnectionIssues, "projectId");

  if (loading || uniqueClustersByProjectId.length === 0) {
    return null;
  }

  const issuesByClusterType: CloudConnectIssuesByClusterType = {
    [ClusterType.GKE]: [],
    [ClusterType.EKS]: [],
  };

  uniqueClustersByProjectId.forEach((cluster) => {
    if (cluster.type in issuesByClusterType) {
      if (issuesByClusterType[cluster.type]) {
        issuesByClusterType[cluster.type]!.push({
          cluster,
        });
      }
    }
  });

  return (
    <Stack spacing={1} sx={{ maxHeight: 300, overflowY: "auto" }}>
      {Object.entries(issuesByClusterType).map(([clusterType, issues]) => (
        <ClusterConnectionIssueAlert
          key={clusterType}
          clusterType={clusterType as ClusterType}
          clusters={issues.map((i) => i.cluster)}
        />
      ))}
    </Stack>
  );
};

export default ClusterTableAlerts;
